'use client';
import styled from 'styled-components';
import { rem } from '@/styles/theme';
import { Subtitle } from '@/components/atoms';
import { useLottie } from 'lottie-react';
import loadingAnimation from '@/assets/lotties/loading.json';
import Dim from '@/components/common/Dim';

const Wrapper = styled.div`
  .alert-box {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    > div {
      text-align: center;
      background: white;
      width: 90%;
      border-radius: ${rem(8)};
      padding: ${rem(6)} 0 ${rem(28)};
    }

    .text-area {
      display: flex;
      flex-direction: column;
      gap: ${rem(10)};
    }
  }
`;

const Loading = () => {
  const options = {
    animationData: loadingAnimation,
    loop: true,
  };
  const { View } = useLottie(options, { width: rem(80), height: rem(54), margin: '0 auto' });
  return (
    <Dim>
      <Wrapper>
        <div className="alert-box">
          <div>
            {View}
            <div className="text-area">
              <div>
                <Subtitle level={4} color="gray-800">
                  금융사 페이지로 이동 후
                </Subtitle>
                <Subtitle level={4} color="gray-800">
                  신청을 진행해 주세요.
                </Subtitle>
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    </Dim>
  );
};

export default Loading;
